import { CheckCircle, AlertTriangle } from 'lucide-react';

import { cn } from '@/lib/utils';

interface StatusBannerProps {
  variant: 'success' | 'error';
  title: string;
  description?: string;
}

export function StatusBanner({ variant, title, description }: StatusBannerProps) {
  const Icon = variant === 'success' ? CheckCircle : AlertTriangle;

  return (
    <div
      className={cn(
        'flex items-start gap-2 rounded-md border px-3 py-2.5',
        variant === 'success' && 'border-success/20 bg-success/5',
        variant === 'error' && 'border-destructive/20 bg-destructive/5'
      )}
    >
      <Icon
        className={cn(
          'mt-0.5 h-4 w-4 shrink-0',
          variant === 'success' && 'text-success',
          variant === 'error' && 'text-destructive'
        )}
      />
      <div className="min-w-0">
        <p className="text-sm font-medium">{title}</p>
        {description && <p className="mt-0.5 text-xs text-muted-foreground">{description}</p>}
      </div>
    </div>
  );
}
